import { EnumSelectField, SelectFieldProps } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { BookablePeriod } from '@mews-commander/data-access';
import { CancellationPolicyFormField } from '../../types';

export const BookablePeriodSelectField = ({ disabled }: Pick<SelectFieldProps, 'disabled'>) => (
    <EnumSelectField
        disabled={disabled}
        enumClass={BookablePeriod}
        enumPrefix="BookablePeriod"
        helper={lt('CancellationPolicyFormBookablePeriodFieldHelper')}
        label={lt('CancellationPolicyFormBookablePeriodFieldName')}
        name={CancellationPolicyFormField.BookablePeriod}
        required
        omitHint
    />
);
